import { Skeleton } from "@/components/ui/skeleton";

export function LoadingBlock({ label = "Loading" }) {
  return (
    <div className="flex flex-col gap-3 p-4" role="status" aria-live="polite" aria-label={label}>
      <Skeleton className="h-4 w-40" />
      <Skeleton className="h-24 w-full" />
      <Skeleton className="h-4 w-64" />
    </div>
  );
}
